export const ApiUrl = {
  // アカウント管理
  API_ACC001: "/accounts/user/revoke", // ユーザアカウント失効化
  API_ACC002: "/accounts/corp-user/refer", // 法人ユーザ参照
  API_ACC003: "/accounts/corp-user/list", // 法人ユーザ一覧参照
  API_ACC004: "/accounts/corp-user/update", // 法人ユーザ更新
  API_ACC005: "/accounts/reregistration/refer", // メールアドレス再登録届参照
  API_ACC006: "/accounts/reset-password/email", // パスワード再発行メール送信
  API_ACC007: "/accounts/reset-password/auth", // パスワード再発行トークン認証
  API_ACC008: "/accounts/reset-password/update", // パスワード変更
  API_ACC009: "/accounts/reregistration/update", // メールアドレス再登録届更新
  API_ACC010: "/accounts/wam-user/refer", // 機構ユーザ参照
  API_ACC011: "/accounts/wam-user/list", // 機構ユーザ一覧参照
  API_ACC012: "/accounts/wam-user/update", // 機構ユーザ更新
  API_ACC013: "/accounts/retirees/update", // 退職者情報登録
  API_ACC014: "/accounts/demander/update", // 請求者情報登録
  API_ACC015: "/accounts/wam-user/create", // 機構ユーザ登録

  // チャット
  API_CHA001: "/chat/list", // スレッド一覧参照
  API_CHA002: "/chat/update", // スレッド更新
  API_CHA003: "/chat/details/list", // スレッド詳細一覧参照
  API_CHA004: "/chat/details/update", // スレッド詳細更新
  API_CHA005: "/chat/chatbot/refer", // チャットボットシーケンス参照

  // 代行者
  API_AGE001: "/agent/list", // 代行者一覧参照
  API_AGE002: "/agent/refer", // 代行者参照
  API_AGE003: "/agent/update", // 代行者更新
  API_AGE004: "/agent/delete", // 代行者削除
  API_AGE005: "/agent-request/list", // 代行入力依頼一覧参照
  API_AGE006: "/agent-request/new/refer", // 代行入力依頼新規
  API_AGE007: "/agent-request/refer", // 代行入力依頼参照
  API_AGE008: "/agent-request/delete", // 代行入力依頼取消
  API_AGE009: "/agent-request/update", // 代行入力依頼更新
  API_AGE010: "/agent-request/completion/update", // 代行入力完了更新

  // 共通
  API_COM001: "/login", // フォーム認証(WEB)
  API_COM002: "/wam/login", // フォーム認証(WAM)
  API_COM003: "/retirees/login", // 退職者認証
  API_COM004: "/refresh-token", // トークン情報更新
  API_COM005: "/report-download", // 帳票ダウンロード(汎用)
  API_COM006: "/general-report-request/update", // 汎用帳票出力要求更新
  API_COM007: "/related-form/update", // 申請等の関連帳票アップロード(汎用)
  API_COM009: "/report-creation-ctatus", // 帳票作成状況取得
  API_COM011: "/bank/refer", // 金融機関検索
  API_COM012: "/branch/refer", // 支店検索
  API_COM013: "/address/refer", // 住所検索

  // 収納・納付請求処理
  API_REC001: "/payment/claim/list", // 入金・請求一覧参照
  API_REC002: "/claim/SCRW160005", // 請求詳細表示
  API_REC003: "/withdrawal/SCRW160006", // 送金一覧表示
  API_REC004: "/transfer/list", // 振込データ参照
  API_REC005: "/payment-sorting/update", // 仕分け処理更新
  API_REC006: "/payment/file/import", // 入金帳票取込参照
  API_REC007: "/non-delivery-details/import", // 不着明細取込参照
  API_REC008: "/claim/status/update", // 請求状況更新
  API_REC009: "/deposit-status/update", // 入金状況更新
  API_REC010: "/transfer-request/update", // 振込情報詳細更新
  API_REC011: "/over-payment/list", // 過納金一覧参照
  API_REC012: "/surcharges/list", // 割増金一覧参照
  API_REC013: "/over-payment/list/update", // 過納金要処理一覧更新
  API_REC014: "/surcharges/status/update", // 割増金請求状態更新
  API_REC015: "/claim-payment/list", // 請求・収納一覧参照
  API_REC016: "/claim/list", // 請求一覧参照
  API_REC017: "/payment/list", // 入金一覧参照
  API_REC018: "/transfer-request/download", // 振込データダウンロード
  API_REC019: "/surcharges/applications-list/update", // 割増金要処理一覧更新
  API_REC020: "/surcharges/SCRW160011", // 割増金請求参照
  API_REC021: "/JOB70/SCRW160007", // 振込情報申請参照
  API_REC022: "/transfer-request/application/update", // 振込情報申請更新
  API_REC023: "/payment-sorting/results/details", // 仕分け結果詳細参照
  API_REC024: "/payment-sorting/release/update", // 仕分け処理解除更新
  API_REC025: "/transfer-request/otheraccount/update", // 機構他口座振替更新
  API_REC026: "/transfer-request/refer", // 請求実績参照
  API_REC027: "/prefectural-subsidy-amount/refer", // 都道府県補助金額参照
  API_REC028: "/prefectural-subsidy-processing-required/refer", // 都道府県補助金要処理参照
  API_REC029: "/transfer-information-details/refer", // 振込情報詳細参照
  API_REC030: "/over-payment/SCRW160011", // 過納金請求参照

  // 各種統計処理
  API_REP001: "/report/list", // 出力結果一覧参照
  API_REP002: "/report/update", // 帳票出力要求更新
  API_REP003: "/report/print-user/update", // データダウンロードユーザ更新

  // 契約者
  API_CON001: "/corps/list", // 契約者一覧参照
  API_CON002: "/JOB01/refer", // 共済契約申請書参照
  API_CON003: "/JOB01-15/staffs/list", // 申請職員名簿一覧参照
  API_CON004: "/JOB07-08/list", // 「俸給の調整額」対象手当一覧参照
  API_CON005: "/JOB07-08/refer", // 「俸給の調整額」対象手当参照
  API_CON006: "/JOB02/refer", // 社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届参照
  API_CON008: "/JOB04/refer", // 退職手当共済契約解除参照
  API_CON009: "/JOB05-06/refer", // 契約者氏名等変更届・共済契約証書再交付申出参照
  API_CON010: "/JOB02/SCRC050107", // 契約解除（契約者でなくなった）解除対象施設一覧表示
  API_CON012: "/JOB07-08/update", // 「俸給の調整額」対象手当更新
  API_CON013: "/JOB02/update", // 社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届更新
  API_CON014: "/JOB03/update", // 中小企業退職金共済契約締結届更新
  API_CON015: "/JOB04/update", // 退職手当共済契約解除更新
  API_CON016: "/JOB05-06/update", // 契約者氏名等変更届・共済契約証書再交付申出更新
  API_CON017: "/within-three-months-retiree/list", // 直近3ヶ月の退職者一覧参照
  API_CON018: "/daily-update-staffs/employee-status/SCRC050111", // 従業状況一覧参照
  API_CON019: "/within-three-months-retiree/bulk", // 直近3ヶ月の退職者一覧更新
  API_CON020: "/corps/manager/update", // 契約者・法人担当者情報更新
  API_CON021: "/JOB09/update", // 契約解除（共済法令違反）内容更新
  API_CON022: "/JOB09/SCRW070008", // 契約解除（共済法令違反）内容表示
  API_CON023: "/JOB03/SCRC050110", // 契約解除（中小企業退職金共済契約締結）内容入力表示
  API_CON024: "/JOB73/refer", // 契約者申請情報参照
  API_CON025: "/corps/manager/refer", // 契約者・担当者情報参照
  API_CON026: "/JOB73/update", // 共済契約申請書更新
  API_CON027: "/JOB01/staffs/refer", // 法人施設職員新規契約情報参照
  API_CON028: "/JOB01/staffs/update", // 法人施設職員新規契約情報更新
  API_CON029: "/JOB01/update", // 契約者申請情報更新
  API_CON030: "/JOB-03-16-18/dialog/delete", // 日々更新法人職員系の退職年月日削除
  API_CON031: "/JOB-03-16-18/dialog/check", // 日々更新法人職員系の退職年月日削除職員確認
  API_CON032: "/JOB04/report/request", // 契約解除（加入者全員の同意）同意書帳票要求更新

  // 情報照会
  API_INQ001: "/inquiry/list", // 検索該当一覧参照
  API_INQ002: "/inquiry/corps/refer", // 契約者照会参照
  API_INQ003: "/inquiry/facilities/refer", // 施設照会参照
  API_INQ004: "/inquiry/staffs/refer", // 職員照会参照
  API_INQ005: "/JOB44/update", // 原簿閲覧請求更新
  API_INQ006: "/inquiry/name-list/refer", // 職員照会各種請求参照
  API_INQ007: "/JOB44/refer", // 原簿閲覧請求登録参照
  API_INQ008: "/JOB48/update", // 源泉徴収書の再発行依頼更新
  API_INQ009: "/JOB74/update", // 退職手当金支給予定額の証明更新
  API_INQ010: "/inquiry/premium-corp-staff/refer", // 掛金対象法人・職員情報照会参照
  API_INQ011: "/JOB78/update", // 原簿閲覧請求メールアドレス更新
  API_INQ012: "/inquiry/update", // 職員照会問い合わせ更新
  API_INQ013: "/inquiry/refer", // 職員照会問い合わせ参照
  API_INQ014: "/inquiry/staffs/update", // 職員照会留保フラグ更新
  API_INQ015: "/inquiry/comments/update", // 照会用コメント更新

  // 掛金
  API_PRE001: "/JOB11/SCRW080001", // 掛金届出状況一覧表示
  API_PRE002: "/JOB11/SCRW080002", // 掛金届出状況詳細表示
  API_PRE003: "/JOB11/comment/update", // 掛金詳細コメント更新
  API_PRE004: "/JOB12/update", // 掛金納付期限延長申請更新
  API_PRE005: "/JOB12/refer", // 掛金納付期限延長申請参照
  API_PRE006: "/JOB11/update", // 掛金納付対象職員届更新
  API_PRE007: "/JOB11/create/refer", // 掛金納付対象職員届作成参照
  API_PRE008: "/JOB11/refer", // 掛金納付対象職員届参照
  API_PRE009: "/JOB80/update", // 掛金納付対象職員届データ提供の同意日更新
  API_PRE010: "/JOB11/check/list", // 掛金納付対象職員届の提出確認参照
  API_PRE011: "/JOB79/7003-8/download", // 掛金納付対象職員届提出控え・振込依頼書参照
  API_PRE012: "/JOB11/SCRC050030", // 施設の登録内容の確認表示
  API_PRE013: "/JOB50/SCRW080003", // 納付掛金の確認表示
  API_PRE015: "/SCRC080001/premium-status/refer", // 掛金納付対象職員届提出についての申請状態取得
  API_PRE016: "/JOB50/update", // 掛金確定後職員情報修正納付額更新

  // 施設
  API_FAC001: "/JOB22/target/list", // 「施設を転換後加入させない旨の届」の取り下げ対象一覧参照
  API_FAC002: "/JOB18/list", // 共済契約対象施設等一部廃止届一覧参照
  API_FAC004: "/JOB01-15/SCRC050101", // 施設情報　新規登録（通常）表示
  API_FAC005: "/JOB21/SCRC050018", // 施設転換後非加入　新規登録表示
  API_FAC006: "/JOB18/SCRC050123", // 職員の異動状況登録表示
  API_FAC007: "/JOB20/refer", // 特定職員数の見込数変更申請表示
  API_FAC008: "/JOB20/update", // 特定職員数の見込数変更届更新
  API_FAC009: "/JOB18/update", // 共済契約対象施設等一部廃止届更新
  API_FAC010: "/JOB18/staff/update", // 共済契約対象施設等一部廃止等届職員名簿更新
  API_FAC011: "/JOB16/update", // 退職手当共済契約部分解除更新
  API_FAC012: "/JOB21/update", // 施設を転換後加入させない旨の届更新
  API_FAC013: "/JOB22/update", // 施設を転換後加入させない旨の取下届更新
  API_FAC014: "/facilities/apply/delete", // 施設情報削除
  API_FAC016: "/JOB17-19/update", // 契約者氏名等変更届・共済契約証書再交付申出施設情報更新
  API_FAC017: "/JOB16/list/update", // 退職手当共済契約部分解除一括更新
  API_FAC018: "/JOB16/select/refer", // 部分解除施設選択表示
  API_FAC019: "/pulldown-facility-list/refer", // プルダウン用有効施設一覧参照
  API_FAC020: "/JOB16/refer", // 部分解除施設詳細参照
  API_FAC021: "/JOB16/list", // 部分解除施設一覧参照
  API_FAC022: "/facilitys/transfer-cd/refer", // 施設引継ぎコード参照
  API_FAC023: "/JOB16/target/list", // 部分解除対象施設一覧表示
  API_FAC024: "/JOB16/delete", // 部分解除対象施設削除
  API_FAC025: "/JOB19/SCRC050017", // 施設情報の変更登録表示
  API_FAC026: "/JOB21/refer", // 施設転換後非加入参照
  API_FAC027: "/JOB15/order/update", // 施設表示順更新(施設等新設届)
  API_FAC028: "/JOB15/list/update", // 施設等新設届一括更新
  API_FAC029: "/JOB01-15/update", // 施設等新設届・申請施設更新
  API_FAC030: "/JOB01/facilities/order/update", // 施設表示順更新(申請施設)
  API_FAC031: "/JOB01/facilities/list", // 申請施設一覧参照
  API_FAC032: "/JOB25/list", // 施設一覧参照(従業状況の更新)
  API_FAC033: "/JOB18/SCRC050120", // 廃止・休止・経営移管施設選択表示
  API_FAC034: "/JOB15/list", // 施設等新設届一覧参照
  API_FAC035: "/JOB18/refer", // 共済契約対象施設等一部廃止届参照
  API_FAC036: "/JOB18/list/update", // 共済契約対象施設等一部廃止届一括更新
  API_FAC037: "/JOB22/refer", // 「施設を転換後加入させない旨の届」の取り下げ参照
  API_FAC038: "/facilitys/list", // 施設一覧取得
  API_FAC039: "/JOB16/report/request", // 部分解除同意書帳票要求更新
  API_FAC040: "/JOB18/SCRC050121", // 施設廃止状況一覧参照
  API_FAC041: "/JOB18/delete", // 廃止対象施設削除
  API_FAC042: "/JOB01-JOB15/register-completed-flg/update", // 職員登録完了更新

  // 業務チェック
  API_BUS001: "/retirement/date/check", // 退職日の整合性チェック
  API_BUS002: "/retirement/monthly-salary-amt/check", // 退職時の本俸月額差分チェック
  API_BUS004: "/retirement-allowance/contractor-cancel/check", // 契約解除時の退職手当金請求者有無チェック
  API_BUS006: "/staffs/reassignment/check", // 配置換えチェック
  API_BUS007: "/JOB-11/check", // 廃止済み施設職員有無および未提出申請有無チェック
  API_BUS008: "/JOB23/check", // 加入登録時の整合性チェック

  // 法人職員
  API_STA002: "/retirees/SCRC060031", // 退職者状況管理一覧参照
  API_STA003: "/JOB31-32-33/refer", // 退職者情報詳細参照
  API_STA004: "/daily-update-staffs/childcare-leave/SCRC060101", // 育休情報　登録表示
  API_STA005: "/daily-update-staffs/salary/update", // 日々更新法人職員俸給更新
  API_STA006: "/daily-update-staffs/childcare-leave/update", // 日々更新法人職員育休更新
  API_STA007: "/JOB23/file-import/update", // 新規登録職員一括更新
  API_STA008: "/JOB31-32-33/update", // 退職者詳細情報更新
  API_STA009: "/daily-update-staffs/list", // 配置換え職員一覧参照
  API_STA010: "/JOB49/refer", // 掛金確定後職員情報参照
  API_STA011: "/JOB-28-29/update", // 配置換え職員一覧更新
  API_STA013: "/JOB49/update", // 掛金確定後職員情報更新
  API_STA014: "/staffs/apply/delete", // 職員情報削除
  API_STA015: "/JOB23/update", // 加入登録手続き更新
  API_STA016: "/JOB23/refer", // 加入登録手続き参照
  API_STA017: "/JOB01-15/staffs/detail/list", // 職員情報登録一覧参照
  API_STA018: "/JOB23/list", // 加入登録手続き一覧参照
  API_STA019: "/staffs/refer", // 職員情報参照
  API_STA020: "/daily-update-staffs/salary/list", // 職員一覧本俸月額参照
  API_STA022: "/daily-update-staffs/update", // 職員情報更新
  API_STA023: "/JOB23/apply/update", // 加入登録手続き申請更新
  API_STA024: "/staffs/apply/refer", // 加入登録手続き修正参照
  API_STA025: "/daily-update-staffs/employee-status/list", // 従業状況更新参照
  API_STA026: "/JOB-28-29/list", // 共済契約対象（外）施設等異動　対象者一覧参照
  API_STA027: "/daily-update-staffs/transfer/update", // 法人職員異動更新
  API_STA028: "/staffs/transfer-cd/refer", // 加入登録手続き引継ぎ参照
  API_STA029: "/retirees/list", // 退職予定者一覧参照
  API_STA030: "/JOB15/facility-transfer/update", // 施設新設職員異動更新
  API_STA032: "/daily-update-staffs/unrecognized-month/update", // 日々更新法人職員系TBLの更新
  API_STA033: "/JOB42-43/update", // 退職手当金追加支給更新
  API_STA034: "/JOB42-43/refer", // 退職手当金追加支給参照
  API_STA035: "/JOB42-43/applications/update", // 退職手当金追加支給要処理更新
  API_STA036: "/salary-adjustment/SCRC060119", // 「俸給の調整額」対象手当申請参照
  API_STA037: "/retirees/SCRC060031/attach-doc/refer", // 書類の添付参照
  API_STA038: "/retirees/SCRC060031/attach-doc/update", // 書類の添付更新
  API_STA039: "/retirees/SCRC060031/withholding/refer", // 源泉徴収票参照
  API_STA040: "/retirees/SCRC060031/withholding/update", // 源泉徴収票更新
  API_STA041: "/JOB31-32-33/delete", // 退職届等一時保存データ削除
  API_STA042: "/JOB10/update", // 日々更新法人職員系・法人職員系TBLの更新
  API_STA043: "/JOB49/applications/update", // 掛金確定後の職員情報の訂正要処理更新

  // 申請情報
  API_APP001: "/procedure-history/list", // 手続履歴一覧参照
  API_APP002: "/procedure-history/update", // 手続履歴状態更新
  API_APP003: "/JOB15/refer", // 施設等新設届参照
  API_APP005: "/JOB28/refer", // 共済契約対象施設への復帰情報参照
  API_APP006: "/JOB28/update", // 共済契約対象施設への復帰情報更新
  API_APP007: "/JOB29/refer", // 共済契約対象外施設への異動情報参照
  API_APP008: "/JOB29/update", // 共済契約対象外施設への異動情報更新
  API_APP009: "/JOB47/refer", // 退職手当金支給決定額の証明依頼 機構参照
  API_APP010: "/JOB47/update", // 退職手当金支給決定額の証明依頼 更新
  API_APP011: "/JOB47/anser/update", // 退職手当金支給決定額の証明依頼の回答の更新
  API_APP012: "/applications/one-time-save/delete", // 一時保存のデータ削除
  API_APP013: "/JOB11/resubmit/update", // 掛金届の再提出
  API_APP014: "/JOB10/update", // 共済法令違反による契約解除に対する従業状況更新
  API_APP015: "/applications/group/refer", // グループ申請情報参照
  API_APP016: "/applications/update", // 申請状況更新
  API_APP017: "/home", // 法人ホーム表示
  API_APP018: "/JOB47/corp/refer", // 退職手当金支給決定額の証明依頼 法人参照

  // 補助金交付申請機能
  API_SUB001: "/JOB51/list", // 補助金交付申請一覧参照
  API_SUB002: "/JOB51/refer", // 補助金交付申請参照
  API_SUB003: "/JOB51/update", // 補助金交付申請更新

  // 要処理対応
  API_APP101: "/applications/list", // 要処理一覧参照
  API_APP102: "/applications/SCRW130001", // メール内容登録・更新表示
  API_APP103: "/applications/manager-name/update", // 要処理一覧　担当者更新
  API_APP104: "/applications/email/update", // メール内容情報更新
  API_APP105: "/applications/unprocessed/list", // 契約者未処理申請届出等一覧参照
  API_APP106: "/applications/list/update", // 要処理一覧　状況更新
  API_APP107: "/applications/group/update", // グループ申請更新
  API_APP108: "/applications/reminder-date/update", // 督促日手動更新
  API_APP109: "/JOB31-32/invoice-abandon/update", // 退職手当金請求放棄更新
  API_APP110: "/JOB31-32/retire-reason/update", // 退職理由更新
  API_APP111: "/JOB79/update", // 掛金納付対象職員届提出控え、振込依頼書ダウンロード状況更新

  // 退職者
  API_RET001: "/retirement-money-payment/refer", // 退職金支払参照
  API_RET002: "/JOB36/refer", // 合算制度利用申出（1回目）参照
  API_RET003: "/JOB36/update", // 合算制度利用申出（1回目）更新
  API_RET004: "/JOB35/refer", // 退職手当金請求参照
  API_RET005: "/JOB35/update", // 退職手当金請求更新
  API_RET006: "/JOB34-37-38/refer", // 退職手当金請求書の取り下げ参照
  API_RET007: "/JOB34-37-38/update", // 「被共済職員退職届、退職手当金請求書、合算制度利用申出書」の取り下げ更新
  API_RET008: "/JOB39/refer", // 退職手当金振込先金融機関変更届参照
  API_RET009: "/JOB39/update", // 退職手当金振込先金融機関変更届更新
  API_RET011: "/retirees/SCRW070009", // 退職者状況一覧参照
  API_RET012: "/retirees/transfer-cd/refer", // 退職者認証コード参照
  API_RET013: "/retirement-money-payment/SCRR410028", // 退職手当金の請求手続き（請求者確認）表示
  API_RET014: "/JOB36/mail/refer", // 退職者申請メール参照
  API_RET015: "/JOB35-36/confirm/refer", // 退職手当金の請求手続き又は合算制度利用手続き確認表示
  API_RET016: "/JOB35-36/delete", // 退職手当金請求、合算制度利用不要データ削除
  API_RET017: "/JOB40/refer", // 受領者変更参照
  API_RET018: "/JOB40/update", // 受領者変更更新
  API_RET019: "/retirees/refer", // 退職者検索
  API_RET020: "/JOB35/personal-number-documents/update", // 退職手当金請求更新(追加・更新書類)
  API_RET021: "/JOB35/personal-number-documents/delete", // 退職手当金請求更新(削除書類)

  // メール
  API_MAI001: "/mails/refer", // メール参照
  API_MAI002: "/mails/list", // メール一覧参照
  API_MAI003: "/mails/update", // メール更新

  // テンプレート管理
  API_TEM001: "/templates/list", // テンプレート一覧参照
  API_TEM002: "/mail-templates/refer", // メールテンプレート参照
  API_TEM003: "/mail-templates/update", // メールテンプレート更新
  API_TEM004: "/mail-templates/delete", // メールテンプレート削除
};
